import { localStorageInstance } from '@gem/modules/storage';

const KEY_NAME = 'chatBackgroundsCustom';

type ChatBackgroundsCustomMap = Record<string, string>;

const getKeyWithUserId = (userId: string | null): string => {
  return userId ? `${KEY_NAME}_${userId}` : KEY_NAME;
};

export const set = (ts: number, url: string, userId: string | null = null): void => {
  const current = get(userId);
  const updated: ChatBackgroundsCustomMap = { ...current, [ts]: url };

  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(updated));
};

export const get = (userId: string | null = null): ChatBackgroundsCustomMap => {
  const value = localStorageInstance.getItem(getKeyWithUserId(userId));

  if (!value) {
    return {};
  }

  try {
    return JSON.parse(value) as ChatBackgroundsCustomMap;
  } catch {
    return {};
  }
};

export const remove = (entityId: string, userId: string | null = null): void => {
  const current = get(userId);

  if (!(entityId in current)) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [entityId]: _, ...rest } = current;

  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(rest));
};

export const removeAll = (userId: string | null = null): void => {
  localStorageInstance.removeItem(getKeyWithUserId(userId));
};
